export default __webpack_public_path__ + "static/media/plant.ca117196.gif";